import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:5001/api',
  headers: {
    'Content-Type': 'application/json'
  }
})

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    // Force logout on account deactivation
    if (error.response?.status === 403 && error.response?.data?.code === 'ACCOUNT_DEACTIVATED') {
      localStorage.removeItem('token')
      window.location.href = '/login?error=account_deactivated'
    }
    // Module not granted — bounce to gateway so user sees what they DO have access to.
    // Skip if already on gateway to avoid a redirect loop.
    if (error.response?.status === 403 && error.response?.data?.code === 'MODULE_NOT_GRANTED') {
      if (window.location.pathname !== '/') {
        window.location.href = '/?error=module_not_granted'
      }
    }
    // Role no longer permits this area (e.g. admin demoted mid-session).
    // Bounce to gateway. Frontend Vuex state may still claim isAdmin until refresh —
    // the redirect forces a clean reload.
    if (error.response?.status === 403 && error.response?.data?.code === 'ROLE_NOT_PERMITTED') {
      if (window.location.pathname !== '/') {
        window.location.href = '/?error=role_changed'
      }
    }
    return Promise.reject(error)
  }
)

export default api
